import { addDays, format } from 'date-fns';
import { format as dateFnsTzFormat, getTimezoneOffset, toZonedTime } from 'date-fns-tz';
import ReactDatePicker from 'react-datepicker';

export const todayAt17 = () => {
    const localDate = new Date();
    localDate.setHours(17);
    localDate.setMinutes(0);
    localDate.setSeconds(0);
    localDate.setMilliseconds(0);
    return localDate;
};

export const nyOffset = getTimezoneOffset('America/New_York');

export const getTradingDayStart = (date: Date = new Date()) => {
    // Now (in NY time)
    const nyNow = new Date(date.getTime() + nyOffset);

    // Is it after 17 NY time? ..else push back 24 hours.
    const currentTradingStart = nyNow.getHours() <= 17 ? addDays(todayAt17(), -1) : todayAt17();

    // Turn the time back to "neutral" (no offset)
    return new Date(currentTradingStart.getTime() - nyOffset);
};

export const tzOptions: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
};

export interface ExtendedDatePicker extends ReactDatePicker<never, undefined> {
    handleBlur(): void;
    handleCalendarClickOutside(): void;
    state: {
        open: boolean;
    };
}
export const formatToUTCDate = (date: Date) => {
    return dateFnsTzFormat(toZonedTime(date, 'UTC'), 'yyyy-MM-dd', { timeZone: 'UTC' });
};

export const formatToDate = (date: Date) => {
    return format(date, 'yyyy-MM-dd');
};

export const getCurrentTradeDate = () => {
    // Now (in NY time)
    const nyNow = toZonedTime(new Date(), 'America/New_York');

    // Is it after 17 NY time?
    // If yes, use tomorrow's 17 NY time as the current trade date.
    // Else use today's 17 NY time as the current trade date.
    const currentTradingStart = nyNow.getHours() <= 17 ? nyNow : addDays(nyNow, 1);
    return getNegatedDate(currentTradingStart);
};

export const getOperationalCurrentTradeDate = () => {
    return new Date(`${formatToUTCDate(getCurrentTradeDate())} 00:00:00`);
};

export const getNegatedDate = (date?: Date) => {
    // Negates the date by the timezone offset of the current date.
    // For example Malaysia time is UTC+8, so we would +8 hours from the date to get the UTC time.
    // For example New York time is UTC-4, so we would -4 hours from the date to get the UTC time.

    let now = new Date();
    if (date) now = date;
    return new Date(now.getTime() - now.getTimezoneOffset() * 60000);
};

export const dateRangeFilterString = (startDate: Date, endDate: Date, dateFormatter) => {
    const start = getNegatedDate(startDate);
    const end = getNegatedDate(endDate);

    return `${dateFormatter.format(start)} - ${dateFormatter.format(end)}`;
};

export type Period = 'custom' | 'daily' | 'weekToDate' | 'lastWeek' | 'monthToDate' | 'lastMonth';
export type PeriodOption = { label: string; value: Period };

export type ExportFormat = 'pdf' | 'xls' | 'csv';
export type ExportFormatOption = { label: string; value: ExportFormat };

export const periodOptions: PeriodOption[] = [
    { label: 'Custom', value: 'custom' },
    { label: 'Daily', value: 'daily' },
    { label: 'Week to Date', value: 'weekToDate' },
    { label: 'Last Week', value: 'lastWeek' },
    { label: 'Month to Date', value: 'monthToDate' },
    { label: 'Last Month', value: 'lastMonth' }
];
